"use client";

import { c as _c } from "react/compiler-runtime";
import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import type { Entry, UnresolvedLink } from "contentful";
import { isEntry } from "@/lib/contentful/guards";
import type { TypeProductSkeleton } from "@/types/contentful/generated";
import { stripZeroWidth } from "@/utils/ContentfulHelper";
import { TrustpilotScript } from "./TrustpilotScript";
import { TrustpilotWidget } from "./TrustpilotWidget";
type ProductEntry = Entry<TypeProductSkeleton, undefined, string>;
interface Props {
  heading?: string;
  products: (ProductEntry | UnresolvedLink<"Entry">)[];
  entryId?: string;
}
export default function ProductReviews(t0) {
  const $ = _c(35);
  const {
    heading,
    products,
    entryId
  } = t0;
  const inspectorProps = useContentfulInspectorMode();
  let T0;
  let skus;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== entryId || $[1] !== heading || $[2] !== inspectorProps || $[3] !== products) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const resolved = products.filter(_temp);
      if (resolved.length === 0) {
        t7 = null;
        break bb0;
      }
      skus = resolved.map(_temp2);
      let t8;
      if ($[13] !== entryId || $[14] !== inspectorProps) {
        t8 = fieldId => entryId ? inspectorProps({
          entryId,
          fieldId
        }) : {};
        $[13] = entryId;
        $[14] = inspectorProps;
        $[15] = t8;
      } else {
        t8 = $[15];
      }
      const tag = t8;
      t3 = "reviews-section";
      t4 = "flex flex-col gap-6 px-6 py-6 w-full max-w-site-content mx-auto";
      if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <TrustpilotScript />;
        $[16] = t5;
      } else {
        t5 = $[16];
      }
      if ($[17] !== heading || $[18] !== tag) {
        t6 = heading && <h2 className="heading-lg text-left" {...tag("heading")}>{heading}</h2>;
        $[17] = heading;
        $[18] = tag;
        $[19] = t6;
      } else {
        t6 = $[19];
      }
      if ($[20] !== tag) {
        t2 = tag("products");
        $[20] = tag;
        $[21] = t2;
      } else {
        t2 = $[21];
      }
      T0 = TrustpilotWidget;
      t1 = skus.join(",");
    }
    $[0] = entryId;
    $[1] = heading;
    $[2] = inspectorProps;
    $[3] = products;
    $[4] = T0;
    $[5] = skus;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    T0 = $[4];
    skus = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($[22] !== T0 || $[23] !== skus || $[24] !== t1) {
    t8 = <T0 key={t1} skus={skus} />;
    $[22] = T0;
    $[23] = skus;
    $[24] = t1;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t2 || $[27] !== t8) {
    t9 = <div {...t2}>{t8}</div>;
    $[26] = t2;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t3 || $[30] !== t4 || $[31] !== t5 || $[32] !== t6 || $[33] !== t9) {
    t10 = <div id={t3} className={t4}>{t5}{t6}{t9}</div>;
    $[29] = t3;
    $[30] = t4;
    $[31] = t5;
    $[32] = t6;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  return t10;
}
function _temp2(p_0) {
  return stripZeroWidth(p_0.fields.sku);
}
function _temp(p) {
  return isEntry(p);
}